define(["angular", "angular-animate", "angular-bootstrap", "../user/user"], function (angular) {
    "use strict";

    return angular.module("moveTripsToUserModule",  ["ngAnimate", "ui.bootstrap", "commonsUserModule"]);
});